import queryString from 'query-string';

const queryStringOptions: queryString.ParseOptions = {
  arrayFormat: 'separator',
  arrayFormatSeparator: ','
};

export default queryStringOptions;
